import React from "react";
import { Routes, Route } from "react-router-dom";
import {
  Entidades,
  EntidadeMembros,
  Configuracoes,
  ChangePassword,
  Benchmarks,
  BlacklistFundos,
  RecursoGarantidor,
  AlertaMembros,
} from "../../../pages";
import EntidadesProvider from "../../../contexts/EntidadesContext";
import { PATHS } from "../../../enums";

const ConfigRoutes = () => {
  return (
    <EntidadesProvider>
      {/* <RecursoGarantidorProvider tipo="entidade"> */}
      <Routes>
        <Route
          path={
            PATHS.configuracoes.nested.entidades.nested["recurso-garantidor"]
              .path
          }
          element={<RecursoGarantidor />}
        />
        <Route
          path={PATHS.configuracoes.nested.entidades.nested.membros.path}
          element={<EntidadeMembros />}
        />
        <Route
          path={PATHS.configuracoes.nested.entidades.path}
          element={<Entidades />}
        />
        <Route
          path={PATHS.configuracoes.nested["alterar-senha"].path}
          element={<ChangePassword />}
        />
        <Route
          path={PATHS.configuracoes.nested["fundos-fechados"].path}
          element={<BlacklistFundos />}
        />
        <Route
          path={PATHS.configuracoes.nested["benchmarks"].path}
          element={<Benchmarks />}
        />
        <Route
          path={
            PATHS.configuracoes.nested.entidades.nested["alerta-usuarios"].path
          }
          element={<AlertaMembros />}
        />
        <Route path={"*"} element={<Configuracoes />} />
      </Routes>
      {/* </RecursoGarantidorProvider> */}
    </EntidadesProvider>
  );
};

export default ConfigRoutes;
